import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';
import NotificationsContainer from '@rio-cloud/rio-uikit/NotificationsContainer';
import { useRef, useState } from 'react';
import { Outlet, useLocation } from 'react-router';

import SessionExpiredInfo from '../components/SessionExpiredInfo';
import DemoControls from '../features/demo/DemoControls';
import AppHeader from '../features/header/AppHeader';
import { TransportProvider } from '../features/transports/TransportContext';
import RouteUpdater from '../routes/RouteUpdater';
import { AppContext } from './AppContext';

import './App.css';

export const OriginalLayout = () => {
    const [drawerHeight, setDrawerHeight] = useState(56);
    const sidebarRef = useRef<HTMLDivElement>(null);
    const [assetTreeTarget, setAssetTreeTarget] = useState<HTMLDivElement | null>(null);
    const materialView = useLocation().pathname === '/materials';

    return (
        <AppContext.Provider value={{ sidebarRef, assetTreeTarget }}>
            <ApplicationLayout data-testid='app-layout' className='bg-lighter'>
                <ApplicationLayout.Header>
                    <AppHeader />
                </ApplicationLayout.Header>
                {materialView && <ApplicationLayout.Sidebar ref={setAssetTreeTarget} />}
                <ApplicationLayout.Sidebar className='right' ref={sidebarRef} />
                <ApplicationLayout.Body
                    bottomBar={<div aria-hidden='true' className='scm-demo-reserved' />}
                    bottomBarHeight={drawerHeight}
                >
                    <NotificationsContainer />
                    <SessionExpiredInfo />
                    <Outlet />
                    <RouteUpdater />
                </ApplicationLayout.Body>
                <DemoControls onHeightChange={setDrawerHeight} />
            </ApplicationLayout>
        </AppContext.Provider>
    );
};

// Standalone wrapper retained for existing consumers and layout tests.
const AppLayout = () => (
    <TransportProvider>
        <OriginalLayout />
    </TransportProvider>
);
export default AppLayout;
